import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-black text-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <h3 className="font-serif-display text-2xl font-bold leading-tight">Chiquinho <span className="italic font-normal">o 01 do Acre</span></h3>
          <p className="text-zinc-400 mt-3 text-sm font-sans-ui">Jornalismo independente do Acre. Notícias com profundidade, autoridade e responsabilidade.</p>
        </div>
        <div>
          <p className="overline text-zinc-500">Editorias</p>
          <ul className="mt-3 space-y-2 text-sm font-sans-ui">
            <li><Link to="/noticias" className="hover:text-red-400">Notícias</Link></li>
            <li><Link to="/destaques" className="hover:text-red-400">Destaques</Link></li>
            <li><Link to="/ultimas" className="hover:text-red-400">Últimas</Link></li>
            <li><Link to="/populares" className="hover:text-red-400">Populares</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-zinc-500">Institucional</p>
          <ul className="mt-3 space-y-2 text-sm font-sans-ui">
            <li><Link to="/sobre" className="hover:text-red-400">Sobre</Link></li>
            <li><Link to="/contato" className="hover:text-red-400">Contato</Link></li>
            <li><Link to="/admin/login" className="hover:text-red-400">Painel Admin</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-zinc-500">Newsletter</p>
          <p className="text-sm text-zinc-400 mt-3 font-sans-ui">Receba as principais notícias do Acre diariamente.</p>
          <form className="mt-3 flex" onSubmit={(e) => e.preventDefault()}>
            <input type="email" placeholder="seu@email.com" className="flex-1 bg-zinc-900 border border-zinc-700 px-3 py-2 text-sm font-sans-ui" data-testid="newsletter-input" />
            <button type="submit" className="bg-red-700 hover:bg-red-600 px-4 text-sm font-sans-ui font-semibold uppercase tracking-widest" data-testid="newsletter-submit">Assinar</button>
          </form>
        </div>
      </div>
      <div className="border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center text-xs text-zinc-500 font-sans-ui">
          <p>© {year} Chiquinho o 01 do Acre. Todos os direitos reservados.</p>
          <p>Rio Branco, Acre · Brasil</p>
        </div>
      </div>
    </footer>
  );
}
